/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseV2,
    PressReleaseV2FromJSON,
    PressReleaseV2FromJSONTyped,
    PressReleaseV2ToJSON,
} from './PressReleaseV2';

/**
 * 
 * @export
 * @interface BookmarkedPressReleasesResponseV2AllOfData
 */
export interface BookmarkedPressReleasesResponseV2AllOfData {
    /**
     * 保存済みプレスリリース一覧
     * @type {Array<PressReleaseV2>}
     * @memberof BookmarkedPressReleasesResponseV2AllOfData
     */
    pressReleases: Array<PressReleaseV2>;
    /**
     * 次のデータを取得する開始点となる識別子
     * @type {string}
     * @memberof BookmarkedPressReleasesResponseV2AllOfData
     */
    nextCursor?: string;
}

export function BookmarkedPressReleasesResponseV2AllOfDataFromJSON(json: any): BookmarkedPressReleasesResponseV2AllOfData {
    return BookmarkedPressReleasesResponseV2AllOfDataFromJSONTyped(json, false);
}

export function BookmarkedPressReleasesResponseV2AllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookmarkedPressReleasesResponseV2AllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pressReleases': ((json['press_releases'] as Array<any>).map(PressReleaseV2FromJSON)),
        'nextCursor': !exists(json, 'next_cursor') ? undefined : json['next_cursor'],
    };
}

export function BookmarkedPressReleasesResponseV2AllOfDataToJSON(value?: BookmarkedPressReleasesResponseV2AllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'press_releases': ((value.pressReleases as Array<any>).map(PressReleaseV2ToJSON)),
        'next_cursor': value.nextCursor,
    };
}

